/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SecurityPlanEnabledResponse {
  /**
  * The security plan enabled status
  */
  'enabled'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SecurityPlanEnabledResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

